var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDownload4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.82,
    height: 17.82,
    viewBox: "0 0 17.82 17.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-download",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2403",
    "data-name": "Path 2403",
    d: "M19.263,31H18.15a.571.571,0,0,0-.557.557v3.713a.571.571,0,0,1-.557.557H4.784a.571.571,0,0,1-.557-.557V31.557A.571.571,0,0,0,3.671,31H2.557A.571.571,0,0,0,2,31.557v5.012a1.489,1.489,0,0,0,1.485,1.485h14.85a1.489,1.489,0,0,0,1.485-1.485V31.557A.571.571,0,0,0,19.263,31Z",
    transform: "translate(0 -18.234)",
    fill: "#8b9095"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2404",
    "data-name": "Path 2404",
    d: "M16.229,15.217a.538.538,0,0,0,.78,0L22.021,10.2a.538.538,0,0,0,0-.78l-.78-.78a.538.538,0,0,0-.78,0l-2.079,2.079a.371.371,0,0,1-.631-.26V2.557A.667.667,0,0,0,17.157,2H16.043a.571.571,0,0,0-.557.557v7.871a.371.371,0,0,1-.631.26L12.776,8.608a.538.538,0,0,0-.78,0l-.78.817a.538.538,0,0,0,0,.78Z",
    transform: "translate(-5.69)",
    fill: "#8b9095"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownload4);
export default __webpack_public_path__ + "static/media/ic-download4.2b10d0ae.svg";
export { ForwardRef as ReactComponent };